import NLS                  from "Dashboard/Core/NLS";
import Store                from "Dashboard/Core/Store";
import Utils                from "Dashboard/Utils/Utils";
import { ReserveType }      from "Utils/API";



// The initial State
const initialState = {
    loading           : true,
    error             : false,
    edition           : 0,
    canCreate         : false,
    canEdit           : false,
    canFilter         : false,
    canImport         : false,
    canExport         : false,
    list              : [],
    total             : 0,
    elem              : {},
    activities        : [],
    notificationTypes : {},
    courts            : {},
    visitTypes        : [],
    statuses          : [],
    sort              : {
        orderBy  : "position",
        orderAsc : 1,
        page     : 0,
        amount   : 50,
    },
};



// The Actions
const actions = {
    /**
     * Starts the Loader
     * @param {Function} dispatch
     * @returns {Void}
     */
    startLoader(dispatch) {
        dispatch({ type : "RESERVE_TYPE_LOADING" });
    },

    /**
     * Fetches the Reserve Type List
     * @param {Function} dispatch
     * @param {Object=}  params
     * @returns {Promise}
     */
    async fetchList(dispatch, params = {}) {
        const data = await ReserveType.getAll(params);
        data.sort = params;
        dispatch({ type : "RESERVE_TYPE_LIST", data });
    },

    /**
     * Fetches a single Reserve Type
     * @param {Function} dispatch
     * @param {Number}   reserveTypeID
     * @returns {Promise}
     */
    async fetchElem(dispatch, reserveTypeID) {
        const data = await ReserveType.getOne({ reserveTypeID });
        dispatch({ type : "RESERVE_TYPE_ELEM", data });
    },

    /**
     * Fetches the Reserve Type Edit data
     * @param {Function} dispatch
     * @returns {Promise}
     */
    async fetchEditData(dispatch) {
        const data = await ReserveType.getEditData();
        dispatch({ type : "RESERVE_TYPE_EDIT", data });
    },

    /**
     * Edits/Creates a Reserve Type
     * @param {Function} dispatch
     * @param {Object}   data
     * @returns {Promise}
     */
    editElem(dispatch, data) {
        return ReserveType.edit(data);
    },

    /**
     * Deletes a Reserve Type
     * @param {Function} dispatch
     * @param {Number}   reserveTypeID
     * @returns {Promise}
     */
    deleteElem(dispatch, reserveTypeID) {
        return ReserveType.delete({ reserveTypeID });
    },
};



/**
 * Parses a single Element
 * @param {Object} elem
 * @returns {Object}
 */
function parseElem(elem) {
    elem.courtCountText  = NLS.pluralize("COURTS_COUNT",    elem.courtCount);
    elem.periodCountText = NLS.pluralize("GENERAL_PERIODS", elem.periodCount);
    return elem;
}

/**
 * The Reducer
 * @param {Object=} state
 * @param {Object=} action
 * @returns {Object}
 */
const reducer = (state = initialState, action = {}) => {
    if (Utils.hasError(action, "RESERVE_TYPE_LIST", "RESERVE_TYPE_ELEM")) {
        return { ...state, loading : false, error : true };
    }

    switch (action.type) {
    case "RESERVE_TYPE_LOADING":
        return {
            ...state,
            loading           : true,
        };

    case "RESERVE_TYPE_LIST":
        return {
            ...state,
            loading           : false,
            error             : false,
            canCreate         : action.data.canCreate,
            canEdit           : action.data.canEdit,
            canFilter         : action.data.canFilter,
            canImport         : action.data.canImport,
            canExport         : action.data.canExport,
            list              : Utils.parseList(action.data.list, parseElem),
            total             : action.data.total,
            sort              : action.data.sort,
        };

    case "RESERVE_TYPE_ELEM":
        return {
            ...state,
            error             : false,
            edition           : state.edition + 1,
            canEdit           : action.data.canEdit,
            elem              : parseElem(action.data.elem),
            activities        : action.data.activities,
            notificationTypes : action.data.notificationTypes,
            courts            : action.data.courts,
            visitTypes        : action.data.visitTypes,
            statuses          : action.data.statuses,
        };

    case "RESERVE_TYPE_EDIT":
        return {
            ...state,
            error             : false,
            edition           : state.edition + 1,
            activities        : action.data.activities,
            courts            : action.data.courts,
            visitTypes        : action.data.visitTypes,
            statuses          : action.data.statuses,
        };

    default:
        return state;
    }
};




// The public API
export default Store.createSlice(initialState, actions, reducer);
